import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Swal from 'sweetalert2';

import useUserStore from '../../stores/Users';
import LoadingView from '../../components/Loading';
import { KopkarTable, SelectColumnFilter } from '../../components/KopkarTable';
import Icon from '../../components/Icon';
import Card from '../../components/SimpleCard';
import { baseAPI } from '../../services/baseAPI';

function Tabunganku() {

  //Roles
  const token = useUserStore((state) => state.token);
  const users = useUserStore((state) => state.user);

  const [isLoading, setIsLoading] = useState(false);
  const [dataTabunganku, setDataTabunganku] = useState([]);
  const [saldo, setSaldo] = useState(0);

  // CONTROLLER & LOAD DATA
  const fetchDataTabunganku = async (id) => {

    await baseAPI
      .get(`/v1/tabunganku/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const data = res.data.data.tabunganku
        const totalSaldo = res.data.data.saldo;
        setDataTabunganku(data);
        setSaldo(totalSaldo);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(`error ${error}`);
      })
  };


  useEffect(() => {
    setIsLoading(true);
    fetchDataTabunganku(users.id);
  }, [token]);


  const tabunganListView = () => {
    const columns = [
      {
        Header: 'No',
        id: 'row',
        width: '2%',
        accessor: 'no',
        sortType: 'basic',
        disableFilters: true,
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.index + 1}</div>,
      },
      {
        Header: 'No Tabungan',
        id: 'notabung',
        width: '5%',
        accessor: 'notabung',
        sortType: 'basic',
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.original.notrxdetailtabung}</div>
      },
      {
        Header: 'Besar Setoran',
        id: 'setoran',
        width: '12%',
        accessor: 'setoran',
        sortType: 'basic',
        Cell: (cellInfo) => <div className='text-left'>{"Rp." + parseFloat(cellInfo.row.original.setoran).toLocaleString('id-ID')}</div>
      },
      {
        Header: 'Jatuh Tempo',
        id: 'tempo',
        width: '12%',
        accessor: 'tempo',
        sortType: 'basic',
        filter: 'includes',
        // Filter: SelectColumnFilter,
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.original.tgl_tempo !== null ? moment(cellInfo.row.original.tgl_tempo).format("DD-MM-YYYY") : "-"}</div>
      },
      {
        Header: 'Total Diterima',
        id: 'total',
        width: '8%',
        accessor: 'total',
        sortType: 'basic',
        filter: 'includes',
        // Filter: SelectColumnFilter,
        Cell: (cellInfo) => <div className='text-left'>{"Rp." + parseFloat(cellInfo.row.original.total).toLocaleString('id-ID')}</div>
      },
      {
        Header: 'Status',
        id: 'status',
        width: '5%',
        accessor: 'total',
        sortType: 'basic',
        filter: 'includes',
        // Filter: SelectColumnFilter,
        Cell: (cellInfo) => <div className='text-left'>{cellInfo.row.original.status}</div>
      },
    ];

    return (
      <>
        {/* Main card */}
        <div className='row row-deck row-cards'>
          <div className="col-md-12">
            <Card styleBody={{ padding: 0, paddingTop: 20 }}>
              <KopkarTable
                title="Tabunganku"
                columns={columns}
                data={dataTabunganku}
                formOne={null}
                formTwo={null}
                formThree={null}
                rowSize={[50, 100, 150]}
              />
            </Card>
          </div>

        </div>
      </>
    )
  };

  // VIEW
  const headerView = () => (
    <>
      <div className='page-header'>
        <div className='row align-items-center'>
          {/* Title */}
          <div className='col'>
            <ol className='breadcrumb'>
              <li className='breadcrumb-item Navbar_title'>
                <Link to='#' style={{ color: '#333' }}>Tabungan</Link> /{' '}
                <Link to='/tabungan/tabunganku' style={{ color: '#333' }}>Tabunganku</Link>
              </li>
            </ol>
          </div>

          {/* Download Report Data */}
          {/* <div className='col-auto ml-auto d-print-none'>
            <Link to="/employee/reportemployee">
              <button
                type="button"
                className="btn btn-gray"
                style={{ marginLeft: 10 }}
                onClick={() => console.log('download report data')}
              >
                <div className="d-flex align-items-center">
                  <Icon name="Download" size={16} style={{ marginRight: 5 }} />{' '}
                  <span>Download Report</span>
                </div>
              </button>
            </Link>
          </div> */}

        </div>
      </div>
    </>
  )

    
   return (
    <div className='container-fluid'>

      {headerView()}

      {/* main content */}
      <div>
        <p>Saldo Tabungan: Rp.{parseFloat(saldo).toLocaleString('id-ID')}</p>
      </div>

      {isLoading ? <LoadingView /> : tabunganListView()}

    </div>

  );

}

export default Tabunganku;